import { formatAmount } from '@scripts/formatters/amount'
import { deleteSpaces } from '@scripts/formatters/string'
import {
  customRule,
  onlyNumbersRule,
  onlyNumbersAndLatinRule,
  onlyNumbersSpacesDotsAndLatinRule,
  withoutSpecialSymbols,
  withoutBeginningSpaces
} from '@scripts/rules/baseRules'

export const amountRule = (value: string) => formatAmount(value, { isAvailableNegative: true })

export const emailRule = (value: string) => deleteSpaces(value)

export const emailCodeRule = (value: string) => onlyNumbersRule(value).charAt(0)

export const nicknameInputRule = (value: string) => withoutSpecialSymbols(withoutBeginningSpaces(value))

export const passwordRule = (value: string) =>
  customRule(value, /[^a-zA-Z0-9~!@#$%^&*()_+\-={}\[\]|;:<,>.?]/g).slice(0, 64)

export const postalCodeRule = (value: string) => onlyNumbersAndLatinRule(value)

export const bankSearchRule = (value: string) =>
  onlyNumbersSpacesDotsAndLatinRule(withoutBeginningSpaces(value))

export const cryptoWalletRule = (value: string) => onlyNumbersAndLatinRule(value)
export const sixDigitCodeRule = (value: string) => onlyNumbersRule(value).slice(0, 6)
